import { global } from '../utils/globals';
import { assert } from '../utils/assert';
import { getBinaryImageMetadata } from '../category-api/binary-image-api';
export default function parseToNodeImage(arrayBuffer, options) {
  const {
    mimeType
  } = getBinaryImageMetadata(arrayBuffer) || {};
  const {
    _parseImageNode
  } = global;
  assert(_parseImageNode);
  return _parseImageNode(arrayBuffer, mimeType, options);
}
//# sourceMappingURL=parse-to-node-image.js.map